<template>
  <div class="account main">
    <div class="mt20">
      <span class="title1">客户账单</span>
    </div>
    <div class="search-one">
      <div class="search-item">
        账单周期：{{this.screenData.bill_start_date||'-'}} 至 {{this.screenData.bill_end_date||'-'}}
      </div>

    </div>
    <section class="account-box mt20">
      <Table border :columns="columns" :data="list">
      </Table>
      <Paging v-bind:page-data="pageData" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </section>
  </div>
</template>
<script>
  import Paging from "@/components/common/paging";
  export default {
    components: {
      Paging
    },
    data() {
      return {
        statusList: [{ //10-待结算，20-已结算，-10-已作废
          value: 10,
          label: '待付款'
        }, {
          value: 20,
          label: '已付款'
        }, {
          value: '-10',
          label: '已作废'
        }],
        pageData: {
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 11 //页面最多显示几个分页组
        },
        screenData: {
          warehouse_id: '',
          PageNum: 1,
          PageSize: 10
        },
        columns: [{
            title: "账单编号",
            key: "client_bill_no",
            tooltip: true,
            width: 180,
          }, {
            title: "客户名称",
            key: "client_name",
            width: 180,
            tooltip: true,
          },
          {
            title: "子账户编号",
            key: "client_code",
            width: 150,
            tooltip: true,
          },
          {
            title: "金额",
            key: "total_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.total_fee || '0.00'));
            }
          },
          {
            title: "出库费",
            key: "out_bill_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.out_bill_fee || '0.00'));
            }
          },
          {
            title: "仓储费",
            key: "stock_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.stock_fee || '0.00'));
            }
          },
          {
            title: "一件代发费",
            key: "post_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.post_fee || '0.00'));
            }
          },
          {
            title: "状态",
            key: "contact_phone",
            width: 120,
            render: (h, params) => {
              let status = params.row.status;
              if (status == 10) {
                return h("span",{
                  style:{
                    color : 'red'
                  }
                }, "待支付");
              } else if (status == 20) {
                return h("span",{
                  style:{
                    color : 'green'
                  }
                }, "已支付");
              } else if (status == -10) {
                return h("span", "已作废");
              }
            }
          },
          {
            title: "结算类型",
            key: "bill_type",
            width: 130,
            render: (h, params) => {
              let bill_type = params.row.bill_type;
              if (bill_type == 10) {
                return h("span", "日结算");
              } else if (bill_type == 20) {
                return h("span", "周结算");
              } else if (bill_type == 30) {
                return h("span", "月结算");
              } else if (bill_type == 40) {
                return h("span", "季度结算");
              } else {
                return h("span", "即时结算");
              }
            }
          }, {
            title: "账单周期",
            key: "bill_start_date",
            width: 200,
            tooltip: true,
            render: (h, params) => {
              let txt = (params.row.bill_start_date|| '') + ' 至 ' + (params.row.bill_end_date||'');
              return h("span", txt);
            }
          },
          {
            title: "操作",
            key: "im_name",
            render: (h, params) => {
              let doms = [];
              doms.push(h('button', {
                'class': "fc-blue",
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path:'/Finance/BillDetails?client_bill_no=' + params.row.client_bill_no
                    })
                  }
                }
              }, '查看'));
              if(params.row.status==10){
                doms.push(h('button', {
                  'class': "fc-blue",
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path:'/Finance/Paying',
                        query:{
                          client_bill_no : params.row.client_bill_no,
                          total_fee : params.row.total_fee,
                          bill_type : params.row.bill_type,
                        }
                      })
                    }
                  }
                }, '确认支付'));
              }
              return h("div", doms);
            }
          }
        ],
        list: [],
      };
    },
    methods: {
      setPage(page) {
        this.pageData.pageIndex = page;
        this.screenData.PageNum = page;
        this.getList();
      },
      chooseSize(size) {
        this.pageData.pageSize = this.screenData.PageSize = size;
        let p = Math.ceil(this.pageData.dataTotal / this.pageData.pageSize);
        if (this.pageData.pageIndex > p) {
          this.pageData.pageIndex = this.screenData.PageNum = p;
        }
        this.getList();
      },
      getList() {
        this.$axios.get("/ClientBill/list", {
          params: this.screenData
        }).then(res => {
          this.list = res.data || [];
          this.pageData.pageTotal = res.pageTotal;
          this.pageData.dataTotal = res.totalSize;
        });
      },

    },
    created() {
      this.screenData.warehouse_id = localStorage.getItem('warehouse_id');

      this.screenData.bill_start_date = this.$route.query.bill_start_date;
      this.screenData.bill_end_date = this.$route.query.bill_end_date;
      this.screenData.bill_type = this.$route.query.bill_type;


      if (this.screenData.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
    }
  };
</script>
<style lang="scss">
  .account-box {
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/list.vue